import { ActionMenuConfig, ActionMenuResolverContext } from '@milanote/roma/application';
import { BoardLink01Icon, AtSignIcon, FaceHappyIcon, Divider02Icon } from '@milanote/roma-icons';

export type InsertMenuContext = ActionMenuResolverContext & {
    locale: string;
    isTaskListContext: boolean;
    insertEmoji: () => void;
    insertDividerLine: () => void;
    insertBoardLink: () => void;
    insertMention: () => void;
};

const showNonTaskListItems = (context: InsertMenuContext) => !context.isTaskListContext;

export const insertMenuConfig: ActionMenuConfig<InsertMenuContext> = [
    {
        id: 'insert',
        items: [
            {
                type: 'action',
                icon: FaceHappyIcon,
                id: 'emoji',
                localeKey: 'emoji',
                onAction: (context) => context.insertEmoji(),
            },
            {
                type: 'action',
                icon: Divider02Icon,
                id: 'dividerLine',
                localeKey: 'dividerLine',
                availabilityPredicate: showNonTaskListItems,
                onAction: (context) => context.insertDividerLine(),
            },
            {
                type: 'action',
                icon: BoardLink01Icon,
                id: 'linkBoard',
                localeKey: 'boardLink',
                onAction: (context) => context.insertBoardLink(),
            },
            {
                type: 'action',
                icon: AtSignIcon,
                id: 'mention',
                localeKey: 'mentions',
                availabilityPredicate: showNonTaskListItems,
                onAction: (context) => context.insertMention(),
            },
        ],
    },
];
